export const SchemaStatuses = Object.freeze({
  Completed: 'Completed',
  InProgress: 'InProgress',
  Pending: 'Pending'
});
